import React, { useEffect, useRef } from "react";

function getLevel(line) {
  const l = line.toLowerCase();
  if (/\berror\b|\bexception\b|\bfatal\b/.test(l)) return "error";
  if (/\bwarn(ing)?\b/.test(l))  return "warn";
  if (/\binfo\b/.test(l))        return "info";
  if (/\bdebug\b|\btrace\b/.test(l)) return "debug";
  return "normal";
}

export default function LogViewer({ logs, loading, error, autoScroll }) {
  const bottomRef = useRef(null);

  useEffect(() => {
    if (autoScroll && bottomRef.current) {
      bottomRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [logs, autoScroll]);

  if (loading) {
    return (
      <div className="log-area">
        <div className="log-empty">⏳ Connecting to log stream…</div>
      </div>
    );
  }

  const firstLiveIndex = logs.findIndex((e) => !e.isHistory);

  return (
    <div className="log-area">
      {error && (
        <div className="log-line level-error">⚠️ {error}</div>
      )}

      {logs.length === 0 && !error && (
        <div className="log-empty">
          Select a log file above to start streaming ↑
        </div>
      )}

      {logs.map((entry, index) => (
        <React.Fragment key={entry.id}>
          {index === firstLiveIndex && firstLiveIndex > 0 && (
            <hr className="history-divider" />
          )}
          <div className={`log-line level-${getLevel(entry.line)}${entry.isHistory ? " is-history" : ""}`}>
            {entry.line}
          </div>
        </React.Fragment>
      ))}

      <div ref={bottomRef} />
    </div>
  );
}
